import moment from "moment";
import { MedicalPaOrder } from "../../../../data-model/medicalPaOrdersModel";
import { generateFullName } from "../../../../utils/generateOrderDataForTable";
import { capitalizeString } from "../../../../utils/stringModifications";

export const generatePrimaryDetails = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const primaryData = [
    {
      headerText: "Plan Name",
      subText: singleMedicalPaOrder?.coverage?.primary?.payer_name ?? "",
    },
    {
      headerText: "Service Type",
      subText: singleMedicalPaOrder?.payload?.service_type ?? "",
    },
    {
      headerText: "Date of Service",
      subText: moment(singleMedicalPaOrder?.payload?.date_of_service).format(
        "MM/DD/YYYY",
      ),
    },
    {
      headerText: "Regimen",
      subText: singleMedicalPaOrder?.payload?.regimen_name ?? "",
    },
    {
      headerText: "Place of Service",
      subText: "11 - Office",
    },
  ];

  return primaryData;
};

export const generatePatientDetails = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const patientData = [
    {
      header: "Patient Name",
      text: capitalizeString(
        generateFullName(
          singleMedicalPaOrder?.demographics?.first_name ?? "",
          "",
          singleMedicalPaOrder?.demographics?.last_name ?? "",
        ),
      ),
    },
    { header: "MRN ID", text: singleMedicalPaOrder?.patient_id },
    {
      header: "DOB",
      text: moment(singleMedicalPaOrder?.demographics?.date_of_birth).format(
        "MM/DD/YYYY",
      ),
    },
    {
      header: "Member ID",
      text: singleMedicalPaOrder?.coverage?.primary?.member_id,
    },
  ];

  return patientData;
};

export const generateProviderDetails = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const providerData = [
    {
      header: "Name",
      text: generateFullName(
        singleMedicalPaOrder?.requesting_practitioner_details?.first_name ?? "",
        "",
        singleMedicalPaOrder?.requesting_practitioner_details?.last_name ?? "",
      ),
    },
    {
      header: "NPI",
      text: singleMedicalPaOrder?.requesting_practitioner_details?.npi ?? "",
    },
    {
      header: "TIN",
      text: singleMedicalPaOrder?.requesting_practitioner_details?.tax_id ?? "",
    },
    {
      header: "Contact No",
      text: singleMedicalPaOrder?.requesting_practitioner_details?.phone ?? "",
    },
  ];

  return providerData;
};
